import { render } from "./SmallReport.vue?vue&type=template&id=1046098d"
import script from "./SmallReport.vue?vue&type=script&lang=js"
export * from "./SmallReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__